/**
 * Function debouncer
 * (see https://davidwalsh.name/javascript-debounce-function)
 * 
 * @param  {function} func       Function to execute or delay.
 * @param  {int}      wait       Detection period in milliseconds. (Defaults to 100)
 * @param  {bool}     immediate  Whether to execute the function at the beginning of
 *                               the detection period (true) or at the end (false).
 * @return {function}            Execution or delay of the function being debounced.
 *
 */

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) {
				func.apply(context, args);
			}
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) {
			func.apply(context, args);
		}
	};
};
